import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { LoggerService } from '@pf/shared-services';
import { NativeBridgeService } from '../native-bridge.service';
import { NativeLogoutResult } from '../models/native-logout-result';
import { IS_CT_WEB_VIEW } from '../is-ct-web-view.token';

@Injectable({ providedIn: 'root' })
export class NativeLogoutService {
    private readonly logger = inject(LoggerService);
    private readonly nativeBridge = inject(NativeBridgeService);
    private readonly isWebView = inject(IS_CT_WEB_VIEW);

    /** Whether the Android-native logout bridge is available in this runtime. */
    get canUseNativeLogout(): boolean {
        return this.isWebView;
    }

    logout(): Observable<boolean> {
        return this.nativeBridge
            .invoke<NativeLogoutResult>('logout', callbackId =>
                window.CT_Native_Logout?.logout(callbackId)
            )
            .pipe(
                tap(result => {
                    if (result.error) {
                        this.logger.error(
                            'Native Logout Error: ' + result.error
                        );
                    }
                }),
                map(result => result.success),
                catchError(err => {
                    this.logger.error('Native Logout failed', err);
                    return of(false);
                })
            );
    }
}
